/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, InputGroup, Row } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { Button, Input, Table } from "../../components";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { AllRentedOrderList } from "../../redux/Slice/Pos/RentedOrderListSlice";
import { toast } from "react-toastify";

const RentedProductList = (props: any) => {
  const { HandleDownload, facilityId } = props;
  const dispatch = useAppDispatch();
  const { RentedProductData, currentPage, rowsPerPage, totalPage, totalRows, errorMessage } =
    useAppSelector((state) => state.RentedOrderList);
  const [key, setKey] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  if (errorMessage) {
    toast.error(errorMessage.message)
  }

  const RentedListHeader = [
    "Sr No",
    "Product",
    "Customer Name",
    "Contact No",
    "Date",
    "Qty",
    "Start Time",
    "Duration",
    "Service Price/30 Min",
    "Total Paid Amount",
    "Status",
  ];
  const RentedListAccessor = [
    "srNo",
    "name",
    "customerName",
    "phone",
    "createdAt",
    "quantity",
    "startTime",
    "duration",
    "rentingPrice",
    "totalAmount",
    "status",
  ];

  const column = RentedListHeader.map((_, index) => ({
    Header: RentedListHeader[index],
    accessor: RentedListAccessor[index],
  }));

  const handleDownload = (id: any) => {
    let selectRentedProduct = RentedProductData.find((item) => item.id == id);
    HandleDownload(selectRentedProduct?.hash, id);
  };

  const convertDate = (date: string) =>
    date?.split("-").reverse().join("-")
      ? date?.split("-").reverse().join("-")
      : "";

  useEffect(() => {
    if (key.length <= 0)
      dispatch(
        AllRentedOrderList({
          page: "1",
          facilityId: facilityId,
          key: "",
          fromDate: convertDate(fromDate),
          toDate: convertDate(toDate),
        })
      );
  }, [key]);

  const NextPage = (nextpage: number) => {
    dispatch(
      AllRentedOrderList({
        page: nextpage,
        facilityId: facilityId,
        key: key,
        fromDate: convertDate(fromDate),
        toDate: convertDate(toDate),
      })
    );
  };

  const PreviousPage = (prevpage: number) => {
    dispatch(
      AllRentedOrderList({
        page: prevpage,
        facilityId: facilityId,
        key: key,
        fromDate: convertDate(fromDate),
        toDate: convertDate(toDate),
      })
    );
  };

  const handleSearch = () => {
    dispatch(
      AllRentedOrderList({
        page: "1",
        facilityId: facilityId,
        key: key,
        fromDate: convertDate(fromDate),
        toDate: convertDate(toDate),
      })
    );
  };

  const handleFromDate = (e: any) => {
    setFromDate(e?.format("DD-MM-YYYY"));
  };

  const handleToDate = (e: any) => {
    setToDate(e?.format("DD-MM-YYYY"));
  };

  const handleSearchByDate = () => {
    dispatch(
      AllRentedOrderList({
        page: "1",
        facilityId: facilityId,
        key: key,
        fromDate: convertDate(fromDate),
        toDate: convertDate(toDate),
      })
    );
  };

  const handleClear = () => {
    setKey("");
    setFromDate("");
    setToDate("");
    dispatch(
      AllRentedOrderList({
        page: "1",
        facilityId: facilityId,
        key: "",
        fromDate: "",
        toDate: "",
      })
    );
  };

  return (
    <>
      <Card>
        <Card.Body className="pb-0">
          <div className="page-title align-items-center d-flex justify-content-between">
            <Card.Title className="mb-0">Services Product List</Card.Title>
          </div>
          <Row className="row-mb">
            <Col lg={3}>
              <div className="text-start">
                <InputGroup>
                  <Input
                    value={key}
                    type="text"
                    id="search-booking"
                    name="search-booking"
                    className="form-control form-control-sm h-auto"
                    placeholder="Search . . ."
                    onChange={(e: any) => setKey(e.target.value)}
                  />
                  <Button
                    disabled={key.length < 3}
                    onClick={handleSearch}
                    type="button"
                    bname="Search"
                    name="search-button"
                    id="search-button"
                    className="btn btn-primary btn-sm rounded-1"
                  />
                </InputGroup>
                {key.length && key.length < 3 ? (
                  <span className="error-msg">
                    Minimum 3 characters required
                  </span>
                ) : key.length >= 3 ? (
                  <span className="error-msg text-wrap w-25">
                    Search by Product Name or First Name or Last Name
                  </span>
                ) : (
                  ""
                )}
              </div>
            </Col>
            <Col lg={4}>
              <label className="form-label me-1"> Start Date : </label>
              <DatePicker
                format="DD-MM-YYYY"
                value={fromDate}
                onChange={handleFromDate}
                render={
                  <InputIcon className="form-control form-control-sm h-auto" />
                }
              />
            </Col>
            <Col lg={4} className="position-relative">
              <InputGroup className="align-items-center">
                <label className="form-label me-1"> End Date : </label>
                <DatePicker
                  format="DD-MM-YYYY"
                  value={toDate}
                  onChange={handleToDate}
                  render={
                    <InputIcon className="border-end-0 form-control form-control-sm h-auto" />
                  }
                  minDate={new Date(fromDate?.split("-").reverse().join("-"))}
                />
                <Button
                  onClick={handleSearchByDate}
                  type="button"
                  bname="Go"
                  name="Go-button"
                  id="go-button"
                  className="btn btn-primary btn-sm rounded-1"
                />
              </InputGroup>
              {fromDate || toDate || key ? (
                <div
                  onClick={handleClear}
                  className="btn btn-link position-absolute top-0"
                  style={{ cursor: "pointer", left: "90%" }}
                >
                  Clear
                </div>
              ) : (
                ""
              )}
            </Col>
            <Col lg={1}></Col>
          </Row>
        </Card.Body>
        <div className="table-responsive">
          <Table
            columns={column}
            data={RentedProductData}
            hideEditAction={true}
            hideViewAction={true}
            hideDeleteAction={true}
            hideDownloadAction={false}
            currentPage={currentPage}
            rowsPerPage={rowsPerPage}
            totalPage={totalPage}
            totalRows={totalRows}
            NextPage={NextPage}
            PreviousPage={PreviousPage}
            show={true}
            isSorting={true}
            HandleDownload={handleDownload}
          />
        </div>
      </Card>
    </>
  );
};

export { RentedProductList };
